const initMoneycareIframe = function() {
  const iframe = document.getElementById('moneycare-iframe');
  if (!iframe) return;

  const allowedOrigins = new Set([
    'https://moneycare.io',
    'https://www.moneycare.io',
  ]);

  function parseIframeNavigation(rawUrl) {
    if (typeof rawUrl !== 'string') return null;

    const url = new URL(rawUrl, 'https://www.moneycare.io');
    const match = url.pathname.match(
      /^\/(?:de\/)?playlist-iframe(?:\/([^/?#]+))?\/?$/
    );
    if (!match) return null;

    return match[1]
      ? { kind: 'detail', playlistId: decodeURIComponent(match[1]) }
    : { kind: 'overview' };
  }

  function onNavRequested(target) {
    if (!target) return;
    if (!target.playlistId) return;
    if (target.kind === 'detail' && target.playlistId) {
      const url = `/trends/${encodeURIComponent(target.playlistId)}#moneycare-iframe`;
      window.navigation.navigate(url);
    }
  }

  function onIframeNav(target) {
    if (!target) return;
    let url = '/trends'
    if (target.kind == 'detail') {
      url = `/trends/${encodeURIComponent(target.playlistId)}#moneycare-iframe`;
    }

    window.history.replaceState(null, null, url);
    iframe.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  window.addEventListener('message', (event) => {
    if (!allowedOrigins.has(event.origin)) return;
    if (event.source !== iframe.contentWindow) return;

    const message = event.data;
    if (!message || message.source !== 'mnc-playlist-iframe') return;

    switch(message.type) {
    case 'IFRAME_HEIGHT_CHANGED':
      const height = message.payload?.height;
      if (typeof height !== 'number' || !Number.isFinite(height)) return;

      iframe.style.height = `${Math.ceil(height)}px`;
      break;
    case 'IFRAME_NAVIGATION_REQUESTED': // navigationMode=host (home)
      onNavRequested(parseIframeNavigation(message.payload?.url));
      break;
    case 'IFRAME_NAVIGATED': // after normal navigation
      onIframeNav(parseIframeNavigation(message.payload?.url))
      break;
    }
  });
}

export default initMoneycareIframe;
